import type { Detail } from "../snak/SnakContext";
import { Sheet } from "./Sheet";
export function DetailSheet({
  detail,
  onClose
}: {
  detail: Detail | null;
  onClose: () => void;
}) {
  return <Sheet open={!!detail} onClose={onClose} kicker={detail?.kicker ?? ""} title={detail?.title ?? ""} footer={<button onClick={onClose} className="h-10 w-full rounded-full border border-rule text-[13px] font-medium text-charcoal transition-colors duration-150 hover:border-ink hover:text-ink" data-id="element-184" data-mp="2rj5key3s5zrt">
          Back to chapter
        </button>} data-id="element-183" data-mp="2hodkvoqn12ue">
      {detail?.body}
    </Sheet>;
}